(function($){
    function resizeOverlay() {
        $('.overlay').each(function(index, value) {      
            let pHeight = $(".overlay-desc", this).innerHeight();
            $(this).css('margin-bottom', `-${pHeight*0.95}px` );
        });
    };
    
    $(function () {
        resizeOverlay();
        $('.overlay').addClass('initialized');
    });

    $(window).on( 'breakpoint_changed', resizeOverlay);
})(jQuery);